module.exports = __webpack_public_path__ + "img/creme_brulee_closeup.474101f1.jpg";